// public/js/ui/layout.js
// Builds the whole app structure in JavaScript

export function createAppLayout() {
  const root = document.getElementById('root');
  if (!root) {
    console.error('#root not found');
    return;
  }

  const appName     = window.APP_CONFIG?.APP_NAME     || 'Superb Tracking';
  const companyName = window.APP_CONFIG?.COMPANY_NAME || 'Superb';
  const year        = new Date().getFullYear();

  root.innerHTML = `
    <div id="app-layout" style="display: flex; overflow: hidden;">

      <!-- SIDEBAR -->
      <div id="sidebar" class="text-white d-flex flex-column">

        <!-- Logo + collapse arrow -->
        <div class="sidebar-head d-flex justify-content-between align-items-center">
          <img src="https://cdn.prod.website-files.com/6831f35eb74a7e5280d7cf98/68752d3c147e3b7928ac6375_Group%201171275250.svg"
               alt="${companyName}" class="sidebar-logo">
          <button id="sidebar-collapse-toggle" class="sidebar-collapse-btn d-none d-md-flex"
                  aria-label="Collapse sidebar" title="Collapse">
            <i class="fa-solid fa-angle-left"></i>
          </button>
        </div>

        <!-- Global tenant scope (docs/tenant-scope.md) -->
        <div id="tenant-scope-widget" class="tenant-scope-widget"></div>

        <nav class="nav flex-column flex-grow-1 sidebar-nav" id="nav-menu"></nav>

        <!-- Footer nav (Settings, Feedback) + Copyright. Logout used to live
             here as well; it is now only in the user dropdown, where it was
             already duplicated. -->
        <div class="sidebar-footer mt-auto">
          <nav class="nav flex-column sidebar-nav sidebar-nav-footer" id="nav-footer"></nav>
          <div class="text-center pt-1" style="border-top:1px solid rgba(255,255,255,0.08);">
            <small style="color:rgba(255,255,255,0.3); font-size:0.56rem; white-space:nowrap;">
              &copy; ${year} ${companyName}. All rights reserved.
            </small>
            <div>
              <!-- The policy has to be reachable from inside the app, not only
                   from an app-store listing. Opens in its own tab so it never
                   throws away unsaved work on the page behind it. -->
              <a href="legal/privacy" target="_blank" rel="noopener"
                 style="color:rgba(255,255,255,0.3); font-size:0.56rem; text-decoration:none;">Privacy Policy</a>
            </div>
          </div>
        </div>

      </div>

      <!-- MAIN AREA -->
      <div id="main-area" class="flex-grow-1 d-flex flex-column overflow-hidden">

        <!-- Top Bar -->
        <div id="topbar" class="bg-white border-bottom px-4 d-flex justify-content-between align-items-center flex-shrink-0">
          <div class="d-flex align-items-center gap-3 min-w-0">
            <!-- Mobile Hamburger -->
            <button id="mobile-sidebar-toggle"
                    class="btn btn-sm btn-outline-secondary d-md-none d-flex align-items-center justify-content-center"
                    style="width: 38px; height: 38px;" aria-label="Menu">
              <i class="fa-solid fa-bars"></i>
            </button>
            <div class="min-w-0">
              <div class="topbar-app-name">${appName}</div>
              <nav id="breadcrumb" class="breadcrumb-bar" aria-label="Breadcrumb"></nav>
              <div id="page-title" class="d-none"></div>
            </div>
          </div>

          <div class="d-flex align-items-center gap-2 gap-lg-3">
            <!-- The Metric/Imperial toggle used to sit here. It is a set-once
                 preference, so it lives in Settings only and the topbar keeps
                 the space (docs/units.md). -->

            <!-- Notifications → Alerts -->
            <button id="btn-notifications" class="topbar-icon-btn" title="Alerts" aria-label="Alerts">
              <i class="fa-solid fa-bell"></i>
              <span id="topbar-alert-badge" class="topbar-badge d-none">0</span>
            </button>

            <!-- Device manual (wiki) -->
            <a id="btn-manual" href="#manual" class="topbar-icon-btn text-decoration-none" title="Device manual" aria-label="Device manual">
              <i class="fa-solid fa-book"></i>
            </a>

            <div id="user-info-top" class="d-flex align-items-center"></div>
          </div>
        </div>

        <!-- Content Area -->
        <div id="main-content" class="flex-grow-1 overflow-auto p-4 bg-light"></div>

        <!-- Map (MapLibre GL JS) -->
        <div id="map-wrapper" class="flex-grow-1 d-none position-relative">
          <div id="map" style="width:100%; height:100%;"></div>
        </div>
      </div>
    </div>

    <!-- Handle to reopen the sidebar after it is collapsed off-screen (desktop). -->
    <button id="sidebar-reopen" class="sidebar-reopen" title="Show menu" aria-label="Show menu">
      <i class="fa-solid fa-angle-right"></i>
    </button>

    <!-- Toast Container -->
    <div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1100;"></div>
  `;

  console.log('✅ App layout constructed via JS (static map-filter-panel removed — the filter is now inserted dynamically right under "Map")');
}